export let insetObject = {
	orderId: "",
	customerName: "",
	orderStatus: "",
	orderSource: "",
	createdDate: ""
}

export let orderStatusTypes = [{
		id: "New",
		name: "Nová",
		icon: "mdi-new-box",
		tooltip: "Nová objednávka",
		color: "primary",
		disabled: false
	},
	{
		id: "InProgress",
		name: "Prebieha",
		// icon: "mdi-pac-man",
		icon: "mdi-electron-framework",
		tooltip: "Vyrába sa",
		color: "warning",
		disabled: true
	}, {
		id: "Done",
		name: "Hotová",
		icon: "mdi-package-variant-closed",
		tooltip: "Vyrobená, čaká na prevzatie",
		color: "#594540",
		disabled: true
	}, {
		id: "Completed",
		name: "Ukončená",
		icon: "mdi-check",
		// icon: "mdi-check",
		tooltip: "Objednávka bola úspešne dodaná a ukončená",
		color: "success",
		disabled: true
	},
	{
		id: "Canceled",
		name: "Zrusená",
		icon: "mdi-close-circle",
		tooltip: "Objednávka bola zrušená",
		color: "error",
		disabled: false
	}
]

export let tableHeaderOrders = [{
		text: "Id",
		value: "orderId",
		align: "left"
	},
	{
		text: "Zákazník",
		value: "customerName",
		align: "left"
	},
	{
		text: "Stav Objednávky",
		value: "orderStatus",
		align: "center"
	},
	{
		text: "Zdroj Objednávky",
		value: "orderSource",
		align: "center"
	},
	{
		text: "Potvrdená",
		value: "isConfirmed",
		align: "left"
	},
	{
		text: "Vytvorená",
		value: "created",
		align: "left"
	},
	{
		text: "Možnosti",
		value: "action",
		align: "left"
	}
]